var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.4,75.91H65.29v-27H47v27H19.91v18.2H47v27H65.29v-27H92.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.4,76.48A56.27,56.27,0,1,1,80.73,95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98,72.58S111.3,78,113.38,82.17s-5,17.92-9.58,20-7.5,11.25-7.5,16.25-3.75,7.09-10.42,1.25-8.71,3.59-8.71,3.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78,130.09a35.32,35.32,0,0,0,17.5,5.42c10.42.42,13.34,10.84,13.34,25,0,0-.91,5.62,1.17,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153,168.85s-3.34-8.75-15-17.5-1.67-24.59,2.92-29.59,27.51,5.42,25-7.5-20,1.25-21.67,1.66-2.08-7.08-2.5-12.08a36.9,36.9,0,0,1,.42-9.17l9.17-.83c4.58-.42,14.58-.84,15.42-4.59s-1.25-9.17-5.84-8.33,2.92-10,2.92-10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.16,120.87s-18.51-1.61-16.43,5.89,13.39,8.45,13.39,8.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.81,64.4s-2.12,13.79-.87,21.29c0,0,10.68,1.65,11.51-.44s-3.41-6.16-2.39-10.2C152.31,62.27,143.31,59.4,140.81,64.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalHealth);
export default __webpack_public_path__ + "static/media/GLOBAL_HEALTH.54658a92975736bd780dc5a68111032c.svg";
export { ForwardRef as ReactComponent };